import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaTagComponent } from '../pa-tag/pa-tag.component';
import { TagItem } from './models/pa-tag-list.model';

@Component({
  selector: 'pa-tag-list',
  standalone: true,
  imports: [CommonModule, PaTagComponent],
  templateUrl: './pa-tag-list.component.html',
  styleUrls: ['./pa-tag-list.component.scss'],
})
export class PaTagListComponent implements OnInit, OnChanges {
  @Input() tags: string[] | TagItem[] = [];

  defaultSeverity = 'info'; 
  processedTags: TagItem[] = [];

  ngOnInit(): void {
    this.processTags();
  }

  ngOnChanges(): void {
    this.processTags();
  }

  private processTags(): void {
    if (!this.tags || !Array.isArray(this.tags)) {
      this.processedTags = [];
      return;
    }

    this.processedTags = this.tags.map(tag => {
      if (typeof tag === 'string') {
        return {
          label: tag,
          severity: this.defaultSeverity
        };
      }
      return {
        label: tag.label,
        severity: tag.severity || this.defaultSeverity
      };
    });
  }
} 